import { useEffect } from 'react';
import { useRouter } from 'next/router';

const LivePreview = () => {
  const router = useRouter();

  useEffect(() => {
    const handleMessage = async (message) => {
      const { origin, data } = message;

      if (origin !== process.env.NEXT_PUBLIC_STRAPI_ORIGIN) {
        return;
      }

      if (data.type === 'strapiUpdate') {
        // Save current scroll position
        const scrollPosition = window.scrollY;
        sessionStorage.setItem('strapiLivePreviewScrollPosition', scrollPosition.toString());

        router.reload();
      } else if (data.type === 'strapiScript') {
        const script = window.document.createElement('script');
        script.textContent = data.payload.script;
        window.document.head.appendChild(script);
      }
    };

    // Add the event listener
    window.addEventListener('message', handleMessage);

    // Let Strapi know we're ready to receive the script
    window.parent?.postMessage({ type: 'previewReady' }, '*');

    // Remove the event listener on unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [router]);

  // Restore scroll position after page load
  useEffect(() => {
    const restoreScrollPosition = () => {
      const savedPosition = sessionStorage.getItem('strapiLivePreviewScrollPosition');
      if (savedPosition) {
        window.scrollTo(0, parseInt(savedPosition, 10));
        sessionStorage.removeItem('strapiLivePreviewScrollPosition');
      }
    };

    // Use a small delay to ensure the page content is rendered
    const timer = setTimeout(restoreScrollPosition, 100);

    return () => clearTimeout(timer);
  }, []);

  return null;
};
export default LivePreview;
